
<app-login-header></app-login-header>

<div class="page-container login-wrapper p-0">

  <!-- Page content -->
  <div class="page-content p-0">

    <!-- Main content -->
    <div class="content-wrapper p-3">
      <div class="row g-3">

        <div class="col-sm-6 col-md-3">
          <div class="card card-list-item h-100">
            <div class="card-body">
              <div class="d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">Total No. of Unit Stations connected on CEMS</h6>
                  <strong [CountTo]="cardDetail['total']" [from]="countFrom" [duration]="countDuration" *ngIf="!industryCardLoader && cardDetail['total']" style="font-size: 40px; color: #86CE6D;"></strong>
                  <strong *ngIf="!industryCardLoader && !cardDetail['total']" style="font-size: 40px; color: #86CE6D;">{{cardDetail['total']}}</strong>
                  <strong *ngIf="industryCardLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="../../assets/images/icons/2.png">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-3">
          <div class="card card-list-item h-100">
            <div class="card-body">
              <div class="d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No of Unit Industries exceeds parameters</h6>
                  <strong [CountTo]="exceedDetail['exceedance']" [from]="countFrom" [duration]="countDuration" *ngIf="!industryCardLoader && exceedDetail['exceedance']" style="font-size: 40px; color: #FB6058;"></strong>
                  <strong *ngIf="!industryCardLoader && !exceedDetail['exceedance']" style="font-size: 40px; color: #FB6058;">{{exceedDetail['exceedance']}}</strong>
                  <strong *ngIf="industryCardLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="../../assets/images/icons/8.png">
                </div>
              </div>
            </div>
          </div>
        </div>

<!--        <div class="col-sm-6 col-md-3">-->
<!--          <div class="card card-list-item h-100">-->
<!--            <div class="card-body">-->
<!--              <div class="d-flex align-items-start">-->
<!--                <div class="flex-grow-1 me-3">-->
<!--                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No. of Unit Stations where CEMS is not functioning</h6>-->
<!--                  <strong [CountTo]="cardDetail['close']" [from]="countFrom" [duration]="countDuration" *ngIf="!industryCardLoader && cardDetail['close']" style="font-size: 40px; color: #814EC1;"></strong>-->
<!--                  <strong *ngIf="!industryCardLoader && !cardDetail['close']" style="font-size: 40px; color: #814EC1;">{{cardDetail['close']}}</strong>-->
<!--                  <strong *ngIf="industryCardLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></strong>-->
<!--                </div>-->
<!--                <div class="flex-shrink-0">-->
<!--                  <img src="../../assets/images/icons/3.png">-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <div class="col-sm-6 col-md-3">
          <div class="card card-list-item h-100">
            <div class="card-body">
              <div class="d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No of Air Emission Unit Stations connected</h6>
                  <strong [CountTo]="cardDetail['air']" [from]="countFrom" [duration]="countDuration" *ngIf="!industryCardLoader && cardDetail['air']" style="font-size: 40px; color: #919191;"></strong>
                  <strong *ngIf="!industryCardLoader && !cardDetail['air']" style="font-size: 40px; color: #919191;">{{cardDetail['air']}}</strong>
                  <strong *ngIf="industryCardLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="../../assets/images/icons/6.png">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-3">
          <div class="card card-list-item h-100">
            <div class="card-body">
              <div class="d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No of Water Effluent Unit Stations connected</h6>
                  <strong [CountTo]="cardDetail['water']" [from]="countFrom" [duration]="countDuration" *ngIf="!industryCardLoader && cardDetail['water']" style="font-size: 40px; color: #119DF3;"></strong>
                  <strong *ngIf="!industryCardLoader && !cardDetail['water']" style="font-size: 40px; color: #119DF3;">{{cardDetail['water']}}</strong>
                  <strong *ngIf="industryCardLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="../../assets/images/icons/7.png">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-3">
          <div class="card card-list-item h-100">
            <div class="card-body">
              <div class="d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No of Air and Water Unit Stations connected</h6>
                  <strong [CountTo]="cardDetail['both']" [from]="countFrom" [duration]="countDuration" *ngIf="!industryCardLoader && cardDetail['both']" style="font-size: 40px; color: #597988;"></strong>
                  <strong *ngIf="!industryCardLoader && !cardDetail['both']" style="font-size: 40px; color: #597988;">{{cardDetail['both']}}</strong>
                  <strong *ngIf="industryCardLoader" style="font-size: 40px; color: #86CE6D;"><img style="height: 60px;" src="/assets/images/load.gif" /></strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="../../assets/images/icons/5.png">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-all-industry-map></app-all-industry-map>

      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="card-title mb-0">Industries Installed CEMS</h5>
          <div class="d-flex">
            <select [(ngModel)]="searchField.emmisionType" (change)="getAllIndustryDetails()" class="form-select form-select-sm">
              <option value=""> Select Monitoring Type </option>
              <option value="air">Air Emission</option>
              <option value="water">Water Effluent </option>
              <option value="both">Air & Water</option>
            </select>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-bordered table-hover mb-0">
              <thead class="table-light">
              <tr>
                <th style="width: 5%;">Sr. No.</th>
                <th style="width: 10%;">Industry OCMMS ID</th>
                <th style="width: 20%;">Industry Name</th>
                <th style="width: 15%;">Industry Address</th>
                <th *ngIf="stateCode != 'DPCC'" style="width: 10%;">Region</th>
                <th style="width: 5%;">CEMS Connection Status</th>
                <th style="width: 20%;">Installed Parameter</th>
                <th style="width: 10%;">Last Data Received</th>
                <th style="width: 5%;">Details</th>
              </tr>
              <tr>
                <th style="padding: 4px;"></th>
                <th style="padding: 4px;">
                  <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.industryId" type="text" class="form-control form-control-sm" (keyup)="getAllIndustryDetails()" placeholder="Search by ID">
                </th>
                <th style="padding: 4px;">
                  <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.industryName" (keyup)="getAllIndustryDetails()" type="text" class="form-control form-control-sm" placeholder="Search by Name">
                </th>
                <th style="padding: 4px;">
                  <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.address" type="text" class="form-control form-control-sm" (keyup)="getAllIndustryDetails()" placeholder="Search by Address">
                </th>
                <th *ngIf="stateCode != 'DPCC'" style="padding: 4px;">
                  <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.region" type="text" class="form-control form-control-sm" (keyup)="getAllIndustryDetails()" placeholder="Search by Region">
                </th>
                <th style="padding: 4px;">
                  <select [(ngModel)]="searchField.status" (change)="getAllIndustryDetails()" class="form-select form-select-sm">
                    <option value=""> Select Status </option>
                    <option value="online"> Online </option>
                    <option value="offline"> Offline </option>
                    <option value="delay"> Delay </option>
                    <option value="under maintenance"> Under Maintenance </option>
                    <option value="closed"> Closed by CPCB/{{stateCode}} </option>
                  </select>
                </th>
                <th style="padding: 4px;">
                  <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.parameter" type="text" class="form-control form-control-sm" (keyup)="getAllIndustryDetails()" placeholder="Search by Parameter Name">
                </th>
                <th style="padding: 4px;"></th>
              </tr>
              </thead>
              <tbody *ngIf="!industryListLoader && allIndustriesDetails.length">
              <tr *ngFor="let industry of allIndustriesDetails let i = index" [attr.data-index]="i">
                <td> {{i + 1}}. </td>
                <td title="{{industry.hr_ocmms_id}}">
                            <span>
                                {{ (industry.hr_ocmms_id.length>15)? ((industry.hr_ocmms_id | slice:0:15)+'...'):(industry.hr_ocmms_id) }}
                            </span>
                </td>
                <td style="text-transform: capitalize;" title="{{industry.name}}">
                  {{(industry.name.length>80)? (industry.name | slice:0:80)+'...':(industry.name)}}
                </td>
                <td title="{{industry.address}}">{{(industry.address.length>80)? (industry.address | slice:0:80)+'...':(industry.address)}}</td>
                <td *ngIf="stateCode != 'DPCC'" style="word-break: break-all;">
                  {{(industry.region_name.length>15)? (industry.region_name | slice:0:15)+'...':(industry.region_name)}}
                </td>
                <td>
                  <span *ngIf="(industry.last_update_date | industryStatus) == 'Delay'" class="badge bg-warning text-dark">{{industry.last_update_date | industryStatus}}</span>
                  <span *ngIf="(industry.last_update_date | industryStatus) == 'Online'" class="badge bg-success"><strong>{{industry.last_update_date | industryStatus}}</strong></span>
                  <span *ngIf="(industry.last_update_date | industryStatus) == 'Offline'" class="badge bg-danger">{{industry.last_update_date | industryStatus}}</span>
                </td>
                <td>
                            <span class="badge me-1 mb-1" [ngStyle]="{ 'background-color': parameter.color, 'border-color': parameter.color }" *ngFor="let parameter of industry.parameter_values">
                                {{ parameter.name }}
                            </span>
                </td>
                <td>
                  <div class="badge bg-primary mb-1">{{industry.last_update_date | date: 'dd/MM/yyyy' }}</div>
                  <div class="badge bg-primary">{{industry.last_update_date?(industry.last_update_date | date: 'H:mm'):'No Data' }}</div>
                </td>
                <td class="text-center">
                  <a class="btn btn-sm btn-primary" [routerLink]="['/industry-public-view']" [queryParams]="{industry_id: industry.id}" title="More detail">
                    <i class="icon-more2"></i>
                  </a>
                </td>
              </tr>
              </tbody>

              <tbody *ngIf="!industryListLoader && !allIndustriesDetails.length">
              <tr>
                <td colspan="12" class="text-center" style="height: 180px;">
                  <div class="badge bg-danger mt-5">No Industry Found</div>
                </td>
              </tr>
              </tbody>

              <tbody *ngIf="industryListLoader">
              <tr>
                <td colspan="12" class="text-center" style="height: 180px;">
                  <div class="mt-5">
                    <img src="/assets/images/load.gif" />
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
